import { useSelector } from 'react-redux'
import { ApplicationState } from '../store'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setProfilePicture } from '../store/profile'
import { Logger } from '../modules'
import { APIRequest } from '../api'

export const useFetchAvatar = (): void => {
	const { profile } = useSelector((state: ApplicationState) => state)
	const { gravatarUrl, avatarBlobUrl } = profile
	const dispatch = useDispatch()

	const fetchAvatar = async (): Promise<void> => {
		if (gravatarUrl && !avatarBlobUrl) {
			const accessToken = APIRequest.getAccessToken()

			const res = await fetch(gravatarUrl, {
				headers: {
					Authorization: `Bearer ${accessToken}`
				}
			})
			const isDefaultAvatar = res.headers.get('Content-Disposition')?.endsWith('default-avatar.png')
			if (isDefaultAvatar) return
			const blob = await res.blob()
			const bloburl = URL.createObjectURL(blob)
			dispatch(setProfilePicture({ avatarBlobUrl: bloburl, url: gravatarUrl }))
		}
	}

	useEffect(() => {
		const mount = async (): Promise<void> => {
			try {
				await fetchAvatar()
			} catch (e) {
				Logger.error(e)
			}
		}
		mount()
	}, [gravatarUrl, avatarBlobUrl])
}
